import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorState } from './ErrorState';

export function RouteError({ error }: { error: unknown }): ReactNode {
  return (
    <div className="mx-auto max-w-lg px-4 py-16">
      <ErrorState error={error} onRetry={() => window.location.reload()} />
    </div>
  );
}

export function NotFound(): ReactNode {
  const { t } = useTranslation();
  return (
    <div className="mx-auto flex max-w-lg flex-col items-center gap-3 px-4 py-20 text-center">
      <p className="text-2xl font-semibold tracking-tight text-default">
        {t('errors.routeNotFound.title')}
      </p>
      <p className="text-xs text-muted">{t('errors.routeNotFound.description')}</p>
      <Link
        to="/"
        className="mt-2 rounded-sm px-2 py-1 text-xs font-medium text-accent-text ring-focus hover:underline"
      >
        {t('nav.overview')}
      </Link>
    </div>
  );
}
